export default "__VITE_ASSET__LPnigFb3__"